export const POSITION_ACTIONS = {
    MOVE: 'position move',
}

export const STATS_ACTIONS = {
    UPDATE: 'stats update',
    SET: 'stats set'
}

export const INVENTORY_ACTIONS = {
    USE_ITEM_BY_SLOT_INDEX: 'inventory use item by slot index',
    ADD_ITEM_QUANTITY_BY_SLOT_INDEX: 'add item quantity by slot index'
}

